import { render, staticRenderFns } from "./index-digital-agency.vue?vue&type=template&id=9bac2586"
import script from "./index-digital-agency.vue?vue&type=script&lang=js"
export * from "./index-digital-agency.vue?vue&type=script&lang=js"
import style0 from "./index-digital-agency.vue?vue&type=style&index=0&id=9bac2586&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports